import React, { useEffect, useState } from "react";
import * as Constants from "../constants"; // adjust path if needed
import "../styles/herobanner.css"; // CSS below

const slides = [
  "assets/landing/Desktop - 5.png",
  "assets/landing/Desktop - 6.png",
  "assets/landing/Desktop - 7.png",
  "assets/landing/Desktop - 8.png",
  "assets/landing/Desktop - 10.png",
  "assets/landing/Desktop - 11.png",
  "assets/landing/Desktop - 12.png",
  "assets/landing/Desktop - 13.png",
  "assets/landing/Desktop - 14.png",
];

const HeroBanner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000); // 4 seconds per slide
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero">
      <div className="hero-slideshow">
        <div className="carousel">
          {slides.map((filename, index) => (
            <img
              key={index}
              src={`${Constants.baseurl}/${filename}`}
              className={`slide ${index === currentSlide ? "active" : ""}`}
              alt={`Slide ${index + 1}`}
            />
          ))}
        </div>
      </div>

      <div className="hero-content">
        <div className="icon-d">
          <h5 className="welcome">
            <span className="icon">
              <i data-lucide="webhook"></i>
            </span>
            <span>Welcome To Lagos State Judiciary</span>
          </h5>
        </div>
        <h1>
          Justice Re-imagined<br />
          for Today&apos;s <span className="tech">Lagos</span>
        </h1>
        <p>
          We are committed to ensuring disputes are resolved fairly, timely,
          transparently and economically by leveraging enabling technology with
          inherent seamless integration of the court processes, structures and
          administration...
        </p>
        <div className="hero-buttons">
          <a href="/login" className="btn blue">
            Login
          </a>
          <a href="#" className="btn dark">
            Learn more...
          </a>
        </div>
        <div className="animate-ball"></div>
      </div>
    </section>
  );
};

export default HeroBanner;
